import * as tslib_1 from "tslib";
import * as React from 'react';
import { getProcessedCss } from 'tpa-style-webpack-plugin/runtime';
import * as utils from '../../constants/constants';
export var withStyles = function (Component, options) {
    var cssFiles = [].concat(options.cssPath || []);
    return /** @class */ (function (_super) {
        tslib_1.__extends(WithStyles, _super);
        function WithStyles(props) {
            var _this = _super.call(this, props) || this;
            _this.numOfLoaded = 0;
            var linksLoaded = true;
            if (utils.canUseDom()) {
                _this.numOfLoaded = document.querySelectorAll("." + props.id + " link").length;
                linksLoaded = _this.numOfLoaded === cssFiles.length;
            }
            _this.state = { linksLoaded: linksLoaded };
            _this.markAsLoaded = _this.markAsLoaded.bind(_this);
            return _this;
        }
        WithStyles.prototype.componentDidMount = function () {
            for (var i = 0; i < document.styleSheets.length; i++) {
                if (typeof document.styleSheets[i].href === 'string') {
                    var filePath = document.styleSheets[i].href.replace(this.props.cssBaseUrl, '');
                    if (cssFiles.indexOf(filePath) > -1) {
                        this.markAsLoaded();
                    }
                }
            }
        };
        WithStyles.prototype.markAsLoaded = function () {
            this.numOfLoaded++;
            if (this.numOfLoaded >= cssFiles.length) {
                this.setState({ linksLoaded: true });
            }
        };
        WithStyles.prototype.render = function () {
            var _this = this;
            var _a = this.props, style = _a.style, styleId = _a.id, isRTL = _a.isRTL, cssBaseUrl = _a.cssBaseUrl;
            var css = getProcessedCss(style, {
                prefixSelector: styleId ? "." + styleId : '',
                isRTL: !!isRTL,
                strictMode: !!options.strictMode,
            });
            return (React.createElement("div", { className: styleId },
                cssBaseUrl
                    ? cssFiles.map(function (fileName) { return (React.createElement("link", { href: "" + cssBaseUrl + fileName, rel: "stylesheet", type: "text/css", key: fileName, onLoad: _this.markAsLoaded })); })
                    : null,
                React.createElement("style", { dangerouslySetInnerHTML: { __html: css } }),
                this.state.linksLoaded ? React.createElement(Component, tslib_1.__assign({}, this.props)) : null));
        };
        return WithStyles;
    }(React.Component));
};
//# sourceMappingURL=withStyles.js.map